import { Heading } from '~components';

import $ from './large-heading.scss';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;
interface iProps {
    title: string;
    subtitle: string;
    image: ImageProps & Required<Pick<ImageProps, 'alt'>>;
    /**
     * Optional CSS value for the gradient overlay, e.g. `linear-gradient(...)`.
     * When omitted, uses the default gradient defined in `large-heading.scss`.
     */
    gradient?: string;
}

export function LargeHeading({ image, title, subtitle, gradient }: iProps): JSX.Element {
    return (
        <div
            className={$.container}
            style={
                gradient
                    ? ({ ['--large-heading-gradient' as any]: gradient } as React.CSSProperties)
                    : undefined
            }
        >
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img {...image} />
            <div className={$.gradient} />
            <div className={$.content}>
                <Heading size='small' className={$.title}>
                    {title}
                </Heading>
                <Heading size='smaller' className={$.subtitle}>
                    {subtitle}
                </Heading>
            </div>
        </div>
    );
}
